var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative"},[_c('client-only',[(_vm.showMap)?_c('div',{staticStyle:{"height":"600px","width":"100%"},attrs:{"id":"map"}}):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }